// Meta (Facebook) Pixel — browser-side conversion tracking for Meta Ads.
//
// Configured from the admin Marketing page (SiteSettings.metaPixel) and
// wired up once in App.js via configureMetaPixel(). Every other file just
// calls trackEvent(...)/trackPageView() — both are safe no-ops until a
// Pixel ID has actually been configured and enabled, so it's fine to sprinkle
// these calls anywhere without checking "is the pixel on" first.

let ready = false;
let pixelId = '';

// Standard Meta Pixel bootstrap snippet (unmodified from Meta's docs, just
// without the <noscript> fallback pixel image, which needs server rendering
// to work and this is a client-only SPA).
function injectPixelScript() {
  /* eslint-disable */
  if (typeof window === 'undefined' || window.fbq) return;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
}

// Call once, on app load, with the metaPixel object from GET /api/site-settings.
export function configureMetaPixel(metaPixel) {
  const enabled = !!metaPixel?.enabled;
  const id = (metaPixel?.pixelId || '').trim();
  if (!enabled || !id || ready) return;

  injectPixelScript();
  pixelId = id;
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  ready = true;
}

export function isMetaPixelReady() {
  return ready;
}

// Fire on every client-side route change *after* the initial load (the
// initial PageView is already sent by configureMetaPixel's init call).
export function trackPageView() {
  if (!ready) return;
  window.fbq('track', 'PageView');
}

// name: any standard Meta event ('ViewContent', 'AddToCart',
// 'InitiateCheckout', 'Purchase', etc). params: plain object of Meta's
// standard parameters (value, currency, content_ids, content_name, ...).
export function trackEvent(name, params) {
  if (!ready) return;
  try {
    window.fbq('track', name, params || {});
  } catch {
    // Never let a broken analytics call break the actual page.
  }
}